import React from "react";
import UIButton from "~/old-ui/UIButton";
import {createUseStyles} from "react-jss";
import {primaryTextColor} from "~/theme";
import * as Sentry from "@sentry/browser";
import UIContainer from "~/old-ui/UIContainer";

export default function UnexpectedErrorScene({error, errorInfo, eventId}) {
  const classes = useStyles();

  return (
    <UIContainer className={classes.container}>
      <h1 className={classes.h1}>Error!</h1>
      <p className={classes.p}>Sorry, error occurred during page rendering. Please reload page and try again.</p>
      {eventId && (
        <UIButton primary large className={classes.btn} onClick={() => {
          Sentry.showReportDialog({eventId});
        }}>Submit feedback</UIButton>
      )}

    </UIContainer>
  )
}


const useStyles = createUseStyles({
  container: {
    padding: [[64, 15, 100]],
    color: primaryTextColor,
  },
  h1: {
    margin: [[0, 0, 46, 0]],
    padding: 0,
    fontSize: 140,
    fontWeight: 'bold',
  },

  p: {
    fontSize: 30,
    margin: [[0, 0, 12]],
    padding: 0,
  },

  btn: {
    width: 280,

    marginTop: 38,

    padding: [[14, 16]],
    fontSize: 18,
  }
});
